import { render } from "./ExpertStatisticsAnswerTime.vue?vue&type=template&id=124571b0"
import script from "./ExpertStatisticsAnswerTime.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsAnswerTime.vue?vue&type=script&lang=js"

import "./ExpertStatisticsAnswerTime.vue?vue&type=style&index=0&id=124571b0&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__